/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from "react";
import { Route as BaseRoute } from "react-router-dom";
export const Route = (props) => React.createElement(BaseRoute, { ...props });
//# sourceMappingURL=Route.js.map